import React from "react";

export const About = (props) => {
  if (!props.data) {
    return <div className="text-center">Yükleniyor...</div>;
  }

  const { paragraph, Why, Why2 } = props.data;
  const lang = props.lang || "tr";

  const stats = {
    tr: [
      { icon: "fa-calendar", title: "2022", text: "Kuruluş" },
      { icon: "fa-check-circle", title: "7", text: "Tamamlanan Proje" }, 
      { icon: "fa-certificate", title: "%100", text: "Özgün Çözüm" },
      { icon: "fa-map-marker", title: "Ankara", text: "Merkezli" }
    ],
    en: [
      { icon: "fa-calendar", title: "2022", text: "Founded" },
      { icon: "fa-check-circle", title: "7", text: "Completed Projects" }, 
      { icon: "fa-certificate", title: "100%", text: "Original Solutions" },
      { icon: "fa-map-marker", title: "Ankara", text: "Based" }
    ],
    ru: [
      { icon: "fa-calendar", title: "2022", text: "Основана" },
      { icon: "fa-check-circle", title: "7", text: "Проектов" }, 
      { icon: "fa-certificate", title: "100%", text: "Оригинально" },
      { icon: "fa-map-marker", title: "Анкара", text: "Штаб" }
    ]
  };

  const currentStats = stats[lang] || stats.tr;

  const leftColumnIcons = ["fa-code-fork", "fa-cogs", "fa-server", "fa-magnet", "fa-check-square"];
  const rightColumnIcons = ["fa-bolt", "fa-wifi", "fa-camera", "fa-wrench", "fa-check-square"];

  return (
    <div id="about" className="about-section">
      <div className="container">
        
        <div className="row top-row-wrapper">
          <div className="col-xs-12 col-md-5">
            <div className="about-logo-card">
              <img src="/img/omemtech.png" className="img-responsive" alt="Omemtech Logo" />
            </div>
          </div>

          <div className="col-xs-12 col-md-7 about-text-area">
            <div className="about-text">
              <h2>{lang === "tr" ? "Hakkımızda" : lang === "ru" ? "О нас" : "About Us"}</h2>
              <div className="heading-underline"></div>
              <p>{paragraph}</p>
            </div>

            <div className="stat-cards-container">
              {currentStats.map((stat, index) => (
                <div className="stat-card" key={index}>
                  <i className={`fa ${stat.icon}`}></i>
                  {/* HATA ÇÖZÜMÜ 1: h4 yerine div kullanıldı (Başlık Hiyerarşisi için) */}
                  <div className="stat-title">{stat.title}</div>
                  <p>{stat.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="expertise-section">
          {/* HATA ÇÖZÜMÜ 2: Başlık Hiyerarşisi korundu */}
          <h3 className="expertise-main-title">
            {lang === "tr" ? "Uzmanlık Alanlarımız" : lang === "ru" ? "Сферы компетенции" : "Areas of Expertise"}
          </h3>
          
          <div className="row expertise-cards-row">
            {Why && Why.length > 0 && (
              <div className="col-xs-12 col-md-6">
                <div className="expertise-card">
                  {/* HATA ÇÖZÜMÜ 3: h4 yerine div kullanıldı */}
                  <div className="expertise-card-title">
                    {lang === "tr" ? "Elektronik & Yazılım" : lang === "ru" ? "Электроника и ПО" : "Electronics & Software"}
                  </div>
                  <ul className="expertise-list">
                    {Why.map((item, i) => (
                      <li key={`why-${i}`}>
                        <i className={`fa ${leftColumnIcons[i] || "fa-check"}`}></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {Why2 && Why2.length > 0 && (
              <div className="col-xs-12 col-md-6">
                <div className="expertise-card">
                  {/* HATA ÇÖZÜMÜ 3: h4 yerine div kullanıldı */}
                  <div className="expertise-card-title">
                     {lang === "tr" ? "Elektromekanik & Sistemler" : lang === "ru" ? "Электромеханика и системы" : "Electromechanics & Systems"}
                  </div>
                  <ul className="expertise-list">
                    {Why2.map((item, i) => (
                      <li key={`why2-${i}`}>
                        <i className={`fa ${rightColumnIcons[i] || "fa-check"}`}></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

          </div>
        </div>

      </div>

      <style>
        {`
          .about-section {
            padding: 100px 0;
            background-color: #f8fafc;
            position: relative;
          }

          .top-row-wrapper {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 60px;
          }

          .about-logo-card {
            background: #ffffff;
            padding: 40px;
            border-radius: 20px;
            box-shadow: 0 10px 40px rgba(0, 229, 255, 0.15); 
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            transition: transform 0.3s ease;
          }
          
          .about-logo-card:hover {
            transform: translateY(-5px);
          }

          .about-text h2 {
            font-size: 36px;
            font-weight: 800;
            color: #0a192f; 
            margin-top: 0;
            margin-bottom: 15px;
            text-transform: uppercase;
          }

          .heading-underline {
            width: 60px;
            height: 4px;
            background-color: #00e5ff; 
            margin-bottom: 25px;
            border-radius: 2px;
          }

          .about-text p {
            font-size: 16px;
            color: #4a5568;
            line-height: 1.8;
            margin-bottom: 30px;
          }

          .stat-cards-container {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 15px;
          }

          .stat-card {
            background: #ffffff;
            padding: 20px 10px;
            border-radius: 15px;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;
            border: 1px solid rgba(0,0,0,0.02);
          }

          .stat-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }

          .stat-card i {
            font-size: 28px;
            color: #e5882a;
            margin-bottom: 12px;
          }

          /* HATA ÇÖZÜMÜ 1 CSS: h4 yerine div olduğu için class yazıldı */
          .stat-card .stat-title {
            font-size: 18px;
            font-weight: 800;
            color: #0a192f;
            margin: 0 0 5px 0;
          }

          /* HATA ÇÖZÜMÜ 4 CSS (Kontrast): #718096 yerine çok daha koyu olan #4a5568 kullanıldı */
          .stat-card p {
            font-size: 14px; /* Boyut bir tık büyütüldü */
            color: #4a5568; 
            margin: 0;
            font-weight: 600; /* Kalınlaştırılarak okunabilirlik artırıldı */
          }

          .expertise-main-title {
            text-align: center;
            font-size: 28px;
            font-weight: 800;
            color: #0a192f;
            margin-bottom: 40px;
          }

          .expertise-cards-row {
            display: flex;
            flex-wrap: wrap;
          }

          .expertise-card {
            background: #ffffff;
            padding: 30px;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
            height: 100%;
            transition: transform 0.3s ease;
            border: 1px solid rgba(0,0,0,0.02);
          }

          .expertise-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
          }

          /* HATA ÇÖZÜMÜ 3 CSS: h4 yerine div. */
          .expertise-card-title {
            font-size: 18px;
            font-weight: 700;
            color: #0a192f;
            margin-top: 0;
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 2px solid #e5882a;
            display: block; /* Div olduğu için blok olarak davransın */
          }

          .expertise-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .expertise-list li {
            display: flex;
            align-items: center;
            margin-bottom: 18px;
          }
          
          .expertise-list li:last-child {
            margin-bottom: 0;
          }

          .expertise-list li i {
            font-size: 20px;
            color: #e5882a;
            width: 35px; 
            text-align: center;
            margin-right: 15px;
          }

          .expertise-list li span {
            font-size: 15px;
            color: #4a5568;
            font-weight: 500;
            line-height: 1.4;
          }

          @media (max-width: 991px) {
            .top-row-wrapper {
              flex-direction: column;
            }
            .about-logo-card {
              margin-bottom: 40px;
            }
            .stat-cards-container {
              grid-template-columns: repeat(2, 1fr);
              gap: 20px;
            }
            .expertise-card {
              margin-bottom: 30px;
            }
          }

          @media (max-width: 767px) {
            .about-text h2 {
              font-size: 28px;
            }
          }
        `}
      </style>
    </div>
  );
};